import React from 'react'
import Pg12 from '../../../myapp/services/add-money/Pg/Pg12.jsx'

function PG12Page() {
  return (
    <Pg12/>
  )
}

export default PG12Page